export default {
      id: "phone-new-usage",
      viewBox: "0 0 29 29",
      url: __webpack_public_path__ + "img/icons.f163a2c6.svg#phone-new",
      toString: function () {
        return this.url;
      }
    }